import React from 'react';
import C18Anchor00 from './C18Anchor00'
import {cl,secsToHm,secsToHms,hmsToSecs,minsToHm, globs} from '../../components/utils/utils';

class C18Duration00 extends React.Component{
  constructor(props) {
    super(props);
    // cl(props)
    this.state={
//       time:this.props.parms.duration,
      text:"",
      focus:false,
      invalid:false,
    }
  }
  
//http://ngsg.link4cloud.com:3104/usa/c18/fui/HumDeHum/1-0-240-0

showDuration=({duration, unit})=>{
    return(unit === "(HH:MM:SS)")?secsToHms(duration): minsToHm(duration)
  }
  
  onFocus=()=>{
//     cl("focus")
    let pa=this.props.parms
    
    // if(pa.minutes)
    let showDur=this.showDuration(pa)
    this.setState({focus:true,text:showDur})
  }
  
  exceedsMax=(dur)=>{
    let pa=this.props.parms
    if(pa.maxDuration==null||dur<0) return false
    let durSecs=(pa.unit==="(HH:MM)")?dur*60:dur
    return durSecs>pa.maxDuration
  }

  onBlur=()=>{
//     cl("blur")
    let dur=hmsToSecs(this.state.text)
    let invalid=this.exceedsMax(dur)
    this.setState({focus:false,time:dur,invalid})
    if(!invalid) this.props.parms.onChange({duration:dur})
  }
  
  render(){
    // cl(this.props.parms.pattern)
    let pr=this.props
    let pa=pr.parms
    // cl(pa)
    let pattern=(this.props.parms.pattern)??"[0-9]:[0-9]{2}:[0-9]{2}"
//     let pattern=(this.props.parms.pattern)||"[0-9]{2}:[0-9]{2}"
//     let tFunc=(this.props.parms.pattern=="[0-9]:[0-9]{2}")?
//       minsToHm:secsToHms
    let showDur=this.showDuration(pa)
    if(pa.minutes){showDur=showDur.slice(-5)}
//     cl(pattern)
    let style=(pa.conflict||this.state.invalid)?{backgroundColor:"#FFCCCC"}:{}
    if(pa.width){style.width=pa.width}
//     cl(style)
//     let style=(pa.width)?{width:pa.width}:{}
    Object.assign(style,pa.style, pa.customCss)
//     cl(style)
    // cl(pr)
    return (
      <>
      <input 
        className="narrow inline-block" 
        style={style}
        title={pr.title}
        id={pr.id}
        type="text" 
        inputMode="numeric" 
        pattern={pattern}
        value={(this.state.focus)?this.state.text:showDur}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={e=>{
          let v=e.currentTarget.value
          let dur=hmsToSecs(v)
          let invalid=this.exceedsMax(dur)
          this.setState({text:v,invalid})
          if(pa.onChange&&!invalid) pa.onChange({duration:dur})
        }}
        onKeyDown={pa.onKeyDown}
        disabled={!pa.saveOK}
      />
      {pa.unit &&
      <span className={`units ${pa.className}`}>{pa.unit}</span>
      }
      </>
    )
  }
}
      
export default C18Duration00;
